import React from 'react'
import {OrderCard} from '../../shared'
import CustomButton from '../../edit/customer/CustomButton'
import capitalize from 'lodash/capitalize'

interface Props {
  orderDeliveryMethod: any
  onClick?: () => void
  isShowEdit?: boolean
}

export const OrderDeliveryMethod: React.FC<Props> = ({orderDeliveryMethod, onClick, isShowEdit}) => {
  return (
    <OrderCard
      title='Delivery Method'
      className='py-6'
      toolbar={onClick && isShowEdit && <CustomButton onClick={onClick}> Edit</CustomButton>}
    >
      <div>
        {/* <select className='form-select' name='deliveryType' value={orderDeliveryMethod} disabled>
          {deliveryMethodTypes.map((delivery, index) => (
            <option key={index} value={delivery.value}>
              {delivery.name}
            </option>
          ))}
        </select> */}
        {capitalize(orderDeliveryMethod)}
      </div>
    </OrderCard>
  )
}

export default OrderDeliveryMethod
